import { CDN_LEVEL_TRAVEL_CRM_SOUNDS } from './cdn';

export const HOLD_SOUND = `${CDN_LEVEL_TRAVEL_CRM_SOUNDS}/hold.mp3`;
export const INCOMING_SOUND = `${CDN_LEVEL_TRAVEL_CRM_SOUNDS}/incoming.mp3`;
export const OUTGOING_SOUND = `${CDN_LEVEL_TRAVEL_CRM_SOUNDS}/outgoing.mp3`;
export const TRANSFER_SOUND = `${CDN_LEVEL_TRAVEL_CRM_SOUNDS}/transfer.mp3`;
